import { Reveal } from "./Reveal";
import { Cross } from "lucide-react";
import { ArchWindow } from "./ArchWindow";

const chapters = [
  { n: "01", title: "SERVE", verse: "Mark 10:45", text: "I have never sent a church an invoice, and I never will. Not for the design, not for the hosting, not for the campaigns that follow. The Son of Man came not to be served but to serve, and every hour I spend on a church's website is given in that same spirit rather than sold." },
  { n: "02", title: "CONNECT", verse: "Acts 1:8", text: "Most people who walk into a church for the first time looked it up on their phone the night before. When a congregation has nothing online, that door closes before anyone reaches it. I build the door, then I make sure the people living around the corner can find it." },
  { n: "03", title: "EMPOWER", verse: "Ephesians 4:12", text: "I don't hand over a website and disappear. I sit down with the pastor, the volunteer who runs the social page, the teenager who films the sermon, and I teach them to carry it forward themselves. The saints do the work of ministry. My job is to equip them well." },
  { n: "04", title: "MULTIPLY", verse: "Matthew 28:19", text: "A sermon preached to fifty people on Sunday can reach five thousand by Friday once it lives online. Every church I put on the web becomes a seed that keeps planting long after I've moved on to the next one. That is how one developer's hours become a mission to the nations." },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-28 md:py-36 relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <div className="flex items-center gap-3">
          <ArchWindow size={14} />
          <span className="font-orbitron text-xs tracking-[0.4em] text-[#E84C4C]">WHY I DO THIS</span>
        </div>
        <h2 className="font-orbitron font-bold text-2xl sm:text-3xl lg:text-4xl text-[#120716] mt-4 max-w-3xl leading-tight">
          THE MESSAGE HASN'T CHANGED.<br />
          <span className="text-[#E84C4C]">THE DOORWAY HAS.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-[#120716]/70 leading-relaxed text-sm md:text-base" data-testid="manifesto-intro">
          Two thousand years ago the Gospel travelled on Roman roads. Today it travels on a phone
          screen, and most churches have never been given a road to stand on. These four commitments
          are how I build one for them.
        </p>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12}>
            <div
              data-testid={`manifesto-chapter-${c.n}`}
              className="group relative h-full rounded-2xl bg-white border border-[#120716]/10 shadow-sm p-10 overflow-hidden transition-all duration-500 hover:border-[#E84C4C]/50 hover:shadow-[0_16px_40px_rgba(232,76,76,0.15)]"
            >
              <span className="absolute -top-6 -right-2 font-orbitron font-black text-[120px] leading-none text-[#E84C4C]/10 group-hover:text-[#E84C4C]/20 transition-colors duration-500 select-none">
                {c.n}
              </span>
              <span className="font-orbitron text-sm tracking-[0.3em] text-[#E84C4C]">{c.n}</span>
              <h3 className="font-orbitron font-bold text-xl sm:text-2xl text-[#120716] mt-3 tracking-wider">{c.title}</h3>
              <p className="mt-4 text-[#120716]/70 leading-relaxed text-sm md:text-base max-w-md">{c.text}</p>
              <p className="mt-6 flex items-center gap-2 text-xs font-orbitron tracking-widest text-[#E84C4C]/80">
                <Cross className="w-3.5 h-3.5" fill="currentColor" /> {c.verse}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
